/* eslint-disable react/require-default-props */
import UiSizes from '@enums/UiSizes';
import React from 'react';
export default function ImageAvatar({ src, borderColor, size = UiSizes.medium }) {
    return (React.createElement("span", { className: `qmb-avatar--${size}` },
        React.createElement("img", { alt: "l", style: { borderRadius: '50%', border: `2px solid ${borderColor}`, boxSizing: 'border-box' }, src: src })));
}
